import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Message, Dimmer, Loader } from 'semantic-ui-react';

import SysadminUserDependentsTable from '../../component/sysadmin/user/user_dependents_table';

import {
  getSystemAdminUserDetail
} from '../../actions';
import { Header } from 'semantic-ui-react';

class SysadminUserDependentsPage extends Component {
    state = {
        isLoading: false,
        userDetail: {},
    }

    componentDidMount() {
        if (this.props.user) {
            const { accessToken } = this.props.user;   
            const { userId } = this.props.match.params;
            if (accessToken) {
                this.setState({ isLoading: true }, () => {
                    console.log('userId', userId)
                    this.props.getSystemAdminUserDetail({ accessToken, userId }, (result, error) => {
                        this.setState({ isLoading: false, userDetail: result.data.user })
                    })
                })
            }
        }
    }

    render() {
        const { userDetail,isLoading } = this.state
        return (
            <Dimmer.Dimmable>
                <Dimmer active={isLoading} inverted>
                    <Loader/>
                </Dimmer>
            { !isLoading &&
            <>
                <Header as="h2">Dependents
                    <Header.Subheader>Name: {userDetail && userDetail.name}</Header.Subheader>
                    <Header.Subheader>NRIC: {userDetail && userDetail.nric}</Header.Subheader>
                </Header>
                <SysadminUserDependentsTable userDetail={userDetail} />
            </>}
            </Dimmer.Dimmable>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.user,
        userDetail: state.systemAdmin.userDetail
    };
}


export default connect(mapStateToProps, {
    getSystemAdminUserDetail,
})(SysadminUserDependentsPage)
